import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {ModalKendo} from "../../lib/ModalKendo";

import {PedidosService} from "../../services/pedidos.service";
import {PedidoLocalService} from "../../services/pedido-local.service";
import {TelaAdicionarProdutoComponent} from "../../pedidos/tela-adicionar-produto/tela-adicionar-produto.component";
import {ComandaService} from "../../services/comanda.service";
import {AdicionaisProdutoUtils} from "../../pedidos/AdicionaisProdutoUtils";
import {ProdutoService} from "../../services/produto.service";
import {ListaDePedidosComponent} from "../../pedidos/lista-de-pedidos/lista-de-pedidos.component";

@Component({
  selector: 'app-editar-itempedido-mesa',
  templateUrl: './modal-editar-itempedido-mesa.component.html',
  styleUrls: ['./modal-editar-itempedido-mesa.component.scss']
})
export class ModalEditarItempedidoMesaComponent extends ModalKendo implements OnInit, OnDestroy  {
  @ViewChild('telaAdicionarProduto') telaAdicionarProduto: TelaAdicionarProdutoComponent;
  @ViewChild('listaDePedidos') listaDePedidos: ListaDePedidosComponent;
  item: any  = {}
  produto: any = {};
  comanda: any = {}
  alterandoItemPedido = false;
  editando = false;
  carregando = true;
  itemAtualizado: any;
  constructor(  private pedidosService: PedidosService, private comandaService: ComandaService,
                private produtoService: ProdutoService,
                private pedidoLocalService: PedidoLocalService) {
    super()
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    let pedidoCopia = Object.assign({}, this.item.pedido)
    pedidoCopia.itens = [this.item];

    this.editando = true;
    this.produtoService.obtenhaProduto(this.item.produto.id, this.item.produto.catalogo, this.comanda.empresa).then((produto: any) => {
      this.produto = produto
      this.carregando  = false;
      let pedido = this.pedidoLocalService.obtenhaPedidoLojaPeloPedidoServer(pedidoCopia);

      this.listaDePedidos.exibaPedido(pedido);
      this.telaAdicionarProduto.setEditarItemPedidoDaMesa(pedido, produto)

    });
  }

  atualizeProduto(dados: any) {
    let indice = dados.indice,
      itemPedido: any = dados.item;

    this.itemAtualizado = itemPedido;
    this.itemAtualizado.id = this.item.id;
    this.listaDePedidos.atualize(indice , itemPedido );
  }

  editeItemPedido(dataItem: any){
    delete this.itemAtualizado;
  }

  salvePedido() {
    //faz nada mesmo
  }

  canceleAdicionar($event: any) {
    this.fecheModal(null)
  }

  confirmeAlteracaoItemPedido(){
    this.alterandoItemPedido = true;

    this.comandaService.altereItemPedido(this.comanda,  this.item.pedido, this.itemAtualizado).then(() => {
      this.fecheModal({ recarregar: true});
    }).catch((err) => {
      this.alterandoItemPedido = false;
      alert(err)
    })
  }


}
